import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import Modal from 'react-modal';

import './output.css';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import './App.css';
import './Toasts.css';
import './product_detail/components/owl.css';
import './supplies/supplies.css';
import './home_page/home-page.css';
import './login/login-register.css';
import './user_info/planet_plus/pp_survey.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import { withRouter } from 'react-router-dom';
import { isLoggedIn, logoutUser } from './common/entities/usuarios';
import { enviosRoute, recoverUserRoute, routes } from './common/constants';
import {
  productDetailRoute,
  articuloRoute,
  carritoRoute,
  homeRoute,
  loginRoute,
  registerRoute,
  testRoute,
  searchRoute,
  wishlistRoute,
  activeUserRoute,
  notificacionesListRoute,
  seguimientoPedidoRoute,
  registerPendingConfirmationRoute,
  recoverRoute,
  userInfoRoute,
  buscadorInsumosRoute,
  serviciosClienteRoute,
  // profileRoute,
  // addressesRoute,
  // ordersRoute,
  Title,
  // TitleConector,
  SubTitle,
} from './common/constants';
import { getCart } from './common/entities/cart';
import { history } from './common/history';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Componentes

// import SuppliesContainer from './supplies/supplies-container.js';
// import Shipments from './shipments/shipments.js';
// import Faqs from './faqs/faqs.js';
// import ServiciosAlCliente from './servicios_al_cliente/servicios-al-cliente.js';
// import ProgramaPuntosPlanetPlus from './servicios_al_cliente/programa-puntos-planet-plus.js';
// import Updates from './servicios_al_cliente/updates';
import CatalogueView from './classes/catalogo';
import HomePageView from './classes/home-page';
import NotificationsView from './classes/notifications';
import PlanetPlusView from './classes/planet-plus';
// import FormasDePago from './servicios_al_cliente/tipos-de-pago.js';
// import SeguimientoPedido from './servicios_al_cliente/seguimiento-pedido.js';
// import QuienesSomos from './servicios_al_cliente/quienes-somos.js';
import Notifications from './notifications/notifications.js';
// import Contacto from './servicios_al_cliente/contacto.js';
// import PoliticasCia from './servicios_al_cliente/politicas-cia.js';
import ScrollToTop from './components/scrollToTop.js';
import HeaderContainer from './header/headerContainer.js';
import Footer from './footer/footer.js';
// import Recover from './login/recover-password.js';
import NotificationList from './header/components/notification-list';
import PaymentError from './checkout/payment-error';
// import RegisterPendingConfirmation from './login/register-pending-confirmation.js';
// import HomePage from './home_page/home-page.js';
// import PPSurvey from './user_info/planet_plus/pp_survey';
// import RecoverUser from './login/recover-user';

// LAS LINEAS COMENTADAS DEBAJO ROMPEN LA APLICACION AL UTILIZAR LAZY LOADING, POR LO QUE SE DEJAN COMENTADAS PARA FUTURAS ACTUALIZACIONES O CAMBIOS EN LA ESTRUCTURA DEL PROYECTO

const Faqs = React.lazy(() => import('./faqs/faqs.js'));
const TyC = React.lazy(() => import('./servicios_al_cliente/terminos-condiciones.js'));
const PoliticasPrivacidad = React.lazy(() => import('./servicios_al_cliente/politicas-privacidad.js'));

const ServiciosAlCliente = React.lazy(() => import('./servicios_al_cliente/servicios-al-cliente.js'));
const ProgramaPuntosPlanetPlus = React.lazy(() =>
  import('./servicios_al_cliente/programa-puntos-planet-plus.js')
);
const Updates = React.lazy(() => import('./servicios_al_cliente/updates'));
// const CatalogueView = React.lazy(() => import('./classes/catalogo'));
// const HomePageView = React.lazy(() => import('./classes/home-page'));
// const NotificationsView = React.lazy(() => import('./classes/notifications'));
// const PlanetPlusView = React.lazy(() => import('./classes/planet-plus'));
const FormasDePago = React.lazy(() => import('./servicios_al_cliente/tipos-de-pago.js'));
const SeguimientoPedido = React.lazy(() => import('./servicios_al_cliente/seguimiento-pedido.js'));
const QuienesSomos = React.lazy(() => import('./servicios_al_cliente/quienes-somos.js'));
//const Notifications = React.lazy(() => import('./notifications/notifications.js'));
const Contacto = React.lazy(() => import('./servicios_al_cliente/contacto.js'));
const PoliticasCia = React.lazy(() => import('./servicios_al_cliente/politicas-cia.js'));
//const ScrollToTop = React.lazy(() => import('./components/scrollToTop.js'));
//const HeaderContainer = React.lazy(() => import('./header/headerContainer.js'));
//const Footer = React.lazy(() => import('./footer/footer.js'));
const Recover = React.lazy(() => import('./login/recover-password.js'));
// const NotificationList = React.lazy(() => import('./header/components/notification-list'));
const RegisterPendingConfirmation = React.lazy(() => import('./login/register-pending-confirmation.js'));
const HomePage = React.lazy(() => import('./home_page/home-page.js'));
const PPSurvey = React.lazy(() => import('./user_info/planet_plus/pp_survey'));
const RecoverUser = React.lazy(() => import('./login/recover-user'));
const Shipments = React.lazy(() => import('./shipments/shipments.js'));
const SuppliesContainer = React.lazy(() => import('./supplies/supplies-container.js'));

const ProductDetail = React.lazy(() => import('./product_detail/product-detail.js'));
const Catalogue = React.lazy(() => import('./catalogue/catalogue.js'));
const Offers = React.lazy(() => import('./catalogue/offers.js'));
const Novedades = React.lazy(() => import('./catalogue/novedades.js'));
const Cart = React.lazy(() => import('./cart/cart.js'));
const LoginForm = React.lazy(() => import('./login/login.js'));
const RegisterForm = React.lazy(() => import('./login/register.js'));
const CheckoutContainer = React.lazy(() => import('./checkout/checkout-container'));
const CompleteOrder = React.lazy(() => import('./checkout/complete-order'));
const RejectedOrder = React.lazy(() => import('./checkout/rejected-order'));

const YourComponent = React.lazy(() => import('./tests/test.js'));
const SearchResults = React.lazy(() => import('./components/search_results/search-results'));
const Wishlist = React.lazy(() => import('./user_info/wishlist/wishlist.js'));
const UserInfoContainer = React.lazy(() => import('./user_info/user-info-container.js'));
const ActivateUser = React.lazy(() => import('./login/activate-user.js'));

const App = () => {
  let location = useLocation();

  const [CartItems, setCartItems] = useState(null);
  const [WishlistItems, setWishlistItems] = useState(null);
  const [Username, setUsername] = useState('');
  const [LoggedInData, setLoggedInData] = useState(undefined);
  const [LoggedIn, setLoggedIn] = useState(false);
  const [loggedInChecked, setLoggedInChecked] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [DistrictsData, setDistrictsData] = useState(null);
  const [RRSSLoginStatus, setRRSSLoginStatus] = useState(null);
  const [NotificationsQty, setNotificationsQty] = useState(0);
  const [NotificationsMsg, setNotificationsMsg] = useState(null);
  const [timeoutIdNotifications, setTimeoutIdNotifications] = useState();
  const [PlanetPlusData, setPlanetPlusData] = useState(null);
  const [UserPendingActivation, setUserPendingActivation] = useState(false);
  const [IdListFromBusqueda, setIdListFromBusqueda] = useState([]);
  const [SelectedPage, setSelectedPage] = useState(null);

  const [contentLoaded, setContentLoaded] = useState(false);

  const handleContentLoaded = () => {
    setContentLoaded(true);
  };

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'js/hubtalk.js';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    document.title = Title + SubTitle;
  }, [location.pathname]);

  useEffect(() => {
    checkLogin();
    getCartItems();
    getPPData();
    // getWishlist();
  }, []);

  useEffect(() => {
    getWishlist();
    // getNotifications();
  }, [LoggedIn]);

  // devuelve lista de items en carrito
  const getCartItems = async () => {
    const cart = await getCart();
    if (cart) {
      setCartItems(cart);
    } else {
      toast.error('Hubo un error  al tratar de obtener tu carrito');
    }
  };

  //agrega item al carrito
  const addCartItems = async (id, qty, pplus = false) => {
    if (parseInt(qty) > 0) {
      let _catalogue = new CatalogueView();
      let _cart = await _catalogue.addToCart(id, parseInt(qty), pplus);

      if (_cart.statusCode === 200) {
        setCartItems(_cart.data);
      } else {
        toast.error(_cart.statusMsg + ' ' + _cart.statusDetail);
      }

      return _cart;
    } else {
      toast.error('Cantidad debe ser mayor que cero');
    }
    getCartItems();
  };

  const getNotifications = async () => {
    if (timeoutIdNotifications) {
      clearTimeout(timeoutIdNotifications);
    }
    setTimeoutIdNotifications(
      setTimeout(async () => {
        let _notifications = new NotificationsView();
        let _res = await _notifications.getNotifications();
        if (_res.data) {
          setNotificationsQty(_res.data.unreadMsgQty);
          setNotificationsMsg(_res.data.msgList);
        }
      }, 750)
    );
  };

  const addWishlistItem = async (artId) => {
    let _homePageView = new HomePageView();
    let _wishlist = await _homePageView.addToWishlist(artId);

    await getWishlist(); // ✅ Esperá a que actualice el estado

    if (_wishlist.statusCode === 200) {
      toast.success('Añadido a favoritos');
    } else {
      toast.error(_wishlist.statusMsg);
    }
  };

  const getWishlist = async () => {
    let _homePageView = new HomePageView();
    let _wishlist = await _homePageView.getWishlist();
    setWishlistItems(_wishlist.data);
  };

  const deleteWishlistItem = async (artId) => {
    let _homePageView = new HomePageView();
    let _wishlist = await _homePageView.deleteWishlistItem(artId);

    await getWishlist(); // ✅ Esperá a que actualice el estado

    if (_wishlist.statusCode === 200) {
      toast.success('Quitado de favoritos');
    } else {
      toast.error(_wishlist.statusMsg);
    }
  };

  const onCartChange = (id, qty, pplus = false) => {
    return addCartItems(id, qty, pplus);
    // getCartItems();
  };

  //borra item del carrito
  const deleteCartItem = async (id) => {
    let _catalogue = new CatalogueView();
    let res = await _catalogue.deleteFromCart(id);
    getCartItems();
  };

  const emptyCart = async (id) => {
    let _catalogue = new CatalogueView();
    let data = await _catalogue.emptyCart();
    getCartItems();
  };

  const toastError = (msg) => {
    toast.error(msg);
  };

  //loguea al usuario
  const handleLogin = async (username, password, token) => {
    let _catalogue = new CatalogueView();
    let _login = await _catalogue.loginUser(username, password, token);
    if (_login && _login.data) {
      setUsername(_login.data.us_nombre);
      setLoggedInData(_login);
      setLoggedIn(true);
      saveUserNameInLocalStorage(username);
    } else if (_login && _login.statusMsg === 'Credenciales incorrectas') {
      toastError('El usuario o contraseña ingresados son incorrectos');
    } else if (_login && _login.statusMsg === 'Usuario pendiente de activación.') {
      setUserPendingActivation(true);
      toastError('El usuario no ha sido activado');
    } else if (_login && _login.statusMsg) {
      toastError(_login.statusMsg);
    } else {
      toastError('Hubo un error al iniciar sesión, ingrese nuevamente en unos minutos');
    }
  };

  const loginUserByActivation = async (email, code, token) => {
    let _catalogue = new CatalogueView();
    let _login = await _catalogue.loginUserByActivation(email, code, token);
    if (_login && _login.data) {
      setUsername(_login.data.us_nombre);
      setLoggedInData(_login);
      setLoggedIn(true);
    } else if (_login && _login.statusMsg === 'Credenciales incorrectas') {
      toastError('El usuario o contraseña ingresados son incorrectos');
    } else {
      toastError('Hubo un error al iniciar sesión, ingrese nuevamente en unos minutos');
    }
  };

  //Loguea al usuario por redes
  const handleLoginRRSS = async (rsId, rsEmail, rsUserId, token, rsToken, rsNombre) => {
    let _catalogue = new CatalogueView();
    let _login = await _catalogue.loginRRSS(rsId, rsEmail, rsUserId, token, rsToken);
    setRRSSLoginStatus(_login.statusCode);
    if (_login.data) {
      setLoggedIn(true);
      setLoggedInData(_login);
      localStorage.setItem('lastLoginSocialMedia', rsNombre);
      let newDate = new Date();
      let date = newDate.getDate();
      let month = newDate.getMonth() + 1;
      let lastLogin = `${date}/${month < 10 ? `0${month}` : `${month}`}`;
      localStorage.setItem('lastLoginDate', lastLogin);
      localStorage.setItem('lastLoginEmail', rsEmail);
      // Limpio el campo de email
      localStorage.removeItem('userName');
    } else if (_login.statusMsg === 'Credenciales incorrectas') {
      toastError('No tenes un usuario creado con este email');
      // } else {
      //   console.log('VIENE DE ACA EL MSG', _login.statusMsg);
      //   toastError(_login.statusMsg);
    }
  };

  const resetLoginStatus = () => {
    setRRSSLoginStatus(null);
  };

  const getPPData = async () => {
    let planetPlus = new PlanetPlusView();
    let res = await planetPlus.getPlanetPlusCtaCte();
    if (res) {
      setPlanetPlusData(res);
      // } else {
      //   toast.error('No pudimos obtener sus datos de PlanetPlus');
    }
  };

  // verifica si el usuario esta logueado
  const checkLogin = async () => {
    var loggedUser = '';
    try {
      const loginRes = await isLoggedIn();
      setUsername(loginRes.us_nombre);
      loggedUser = loginRes.us_nombre;
      setLoggedIn(true);
      setLoggedInData(loginRes);
    } catch (e) {
      setUsername('');
      setLoggedIn(false);
      setLoggedInData(null);
    } finally {
      setLoggedInChecked(true);
    }

    setTimeout(function () {
      var chatWidget = window.w18bd1f04a3d4b674757e14e6b42e7c2f;
    }, 2000);
  };

  //desloguea al usuario
  const handleLogout = async () => {
    if (await tieneArticulosPlanetPlus()) {
      setIsLoggingOut(true);
    } else {
      logOutHandler();
    }
  };

  const logOutHandler = async () => {
    setIsLoggingOut(false);
    let _logout = await logoutUser();

    if (_logout.statusCode === 200) {
      checkLogin();
      setLoggedIn(false);
      setLoggedInData(null);
      var chatWidget = window.w18bd1f04a3d4b674757e14e6b42e7c2f;
      chatWidget.API.Network.changeNick('cambio');
      window.location.replace('/');
    }
  };

  const getDistrictsData = async (url) => {
    let _catalogue = new CatalogueView();
    let _res = await _catalogue.getDistricts(url);
    setDistrictsData(_res);
  };

  const saveUserNameInLocalStorage = (_username) => {
    localStorage.setItem('userName', _username);
  };

  const listofPages = [
    /* See full project for reference */
    loginRoute,
    registerRoute,
    recoverRoute,
    recoverUserRoute,
  ];

  const onCancelActivation = () => {
    setUserPendingActivation(false);
  };

  const tieneArticulosPlanetPlus = async () => {
    await getCartItems();

    const tienePP = CartItems.products.find((ci) => {
      return ci.ci_pplus == 1;
    });

    return tienePP;
  };

  const homePage = () => {
    return (
      <HomePage
        onContentLoaded={handleContentLoaded}
        PlanetPlusData={PlanetPlusData}
        wishlistItems={WishlistItems}
        addWishlistItem={addWishlistItem}
        deleteWishlistItem={deleteWishlistItem}
        loggedInChecked={LoggedIn}
        username={Username}
        onCartChange={onCartChange}
        addCartItems={addCartItems}
        history={history}
      />
    );
  };

  useEffect(() => {}, [IdListFromBusqueda]);
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      backgroundColor: 'none',
      background: 'none',
      zId: '1200',
    },
  };
  return (
    <div>
      {listofPages.indexOf(location.pathname) > -1 || location.pathname.includes('login') ? (
        <>
          <React.Suspense fallback={<span></span>}>
            <Switch location={location}>
              <Route path={`${loginRoute}/:error?/:origin?/:id?`}>
                <LoginForm
                  handleLogin={handleLogin}
                  username={Username}
                  LoggedIn={LoggedIn}
                  handleLoginRRSS={handleLoginRRSS}
                  RRSSLoginStatus={RRSSLoginStatus}
                  ResetLoginStatus={resetLoginStatus}
                  UserPendingActivation={UserPendingActivation}
                  onCancelActivation={onCancelActivation}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>
              <Route path={`${registerRoute}/:error?/:origin?/:id?/`}>
                <RegisterForm
                  handleLogin={handleLogin}
                  handleLogout={handleLogout}
                  username={Username}
                  LoggedIn={LoggedIn}
                  checkLogin={checkLogin}
                  handleLoginRRSS={handleLoginRRSS}
                  RRSSLoginStatus={RRSSLoginStatus}
                  ResetLoginStatus={resetLoginStatus}
                  history={history}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>{' '}
              <Route exact path={recoverRoute}>
                <Recover />
              </Route>
              <Route exact path={recoverUserRoute}>
                <RecoverUser LoggedIn={LoggedIn} />
              </Route>
            </Switch>
            <Footer handleLogout={handleLogout} />
          </React.Suspense>
        </>
      ) : (
        <>
          <ScrollToTop />
          <Modal
            isOpen={isLoggingOut}
            onRequestClose={() => {
              setIsLoggingOut(false);
            }}
            contentLabel="LogOut Modal"
            style={customStyles}
          >
            {isLoggingOut && (
              <div className="modal-dialog modal-large" role="document">
                <div className="modal-content">
                  <div className="modal-header bg-primary">
                    <h4 className="modal-title text-white">Log out</h4>
                  </div>
                  <div className="modal-footer">
                    <div>Si finaliza el log out se sacaran del carrito los articulos de Planet Plus.</div>
                    <div>
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        onClick={() => {
                          logOutHandler();
                        }}
                      >
                        &nbsp; Log out
                      </button>
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        onClick={() => {
                          setIsLoggingOut(false);
                        }}
                      >
                        &nbsp; Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal>
          <HeaderContainer
            cartItems={CartItems}
            deleteCartItem={deleteCartItem}
            username={Username}
            handleLogout={handleLogout}
            loggedInData={LoggedInData}
            WishlistItems={WishlistItems}
            NotificationsQty={NotificationsQty}
            NotificationsMsg={NotificationsMsg}
            getNotifications={getNotifications}
          />
          <Suspense fallback={<span></span>}>
            <Switch location={location}>
              <Route
                path="/wa-contact"
                component={() => {
                  location.href = 'https://wa.me/5491136653543';
                  return null;
                }}
              />

              <Route path={`${articuloRoute}/:id`}>
                <ProductDetail
                  loggedInChecked={LoggedIn}
                  deleteWishlistItem={deleteWishlistItem}
                  WishlistItems={WishlistItems}
                  onCartChange={onCartChange}
                  checkLogin={checkLogin}
                  loggedInData={LoggedInData}
                  addWishlistItem={addWishlistItem}
                  cartItems={CartItems}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route path={`${productDetailRoute}/:id`}>
                <ProductDetail
                  loggedInChecked={LoggedIn}
                  deleteWishlistItem={deleteWishlistItem}
                  WishlistItems={WishlistItems}
                  onCartChange={onCartChange}
                  checkLogin={checkLogin}
                  loggedInData={LoggedInData}
                  addWishlistItem={addWishlistItem}
                  cartItems={CartItems}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path={activeUserRoute}>
                <ActivateUser
                  loginUserByActivation={loginUserByActivation}
                  LoggedIn={LoggedIn}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route path={`${homeRoute}/:LoggedIn?`} onContentLoaded={handleContentLoaded}>
                {homePage()}
              </Route>
              <Route path={`${carritoRoute}`}>
                <Cart
                  cartItems={CartItems}
                  deleteCartItem={deleteCartItem}
                  addCartItems={addCartItems}
                  emptyCart={emptyCart}
                  getCartItems={getCartItems}
                  checkLogin={checkLogin}
                  PlanetPlusData={PlanetPlusData}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path={enviosRoute}>
                <Shipments onContentLoaded={handleContentLoaded} />
              </Route>

              <Route exact path={`${seguimientoPedidoRoute}/:id?`}>
                <SeguimientoPedido
                  loggedInChecked={LoggedIn}
                  getCartItems={getCartItems}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path={notificacionesListRoute}>
                <NotificationList
                  loggedInChecked={LoggedIn}
                  NotificationsMsg={NotificationsMsg}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path="/ProgramaPlanetPlus">
                <ProgramaPuntosPlanetPlus onContentLoaded={handleContentLoaded} />
              </Route>

              <Route exact path="/EncuestaPlanetPlus">
                <PPSurvey
                  onContentLoaded={handleContentLoaded}
                  loggedInData={LoggedInData}
                  loggedIn={LoggedIn}
                />
              </Route>

              {/* <Route exact path="/buscador-angolia">
                <AngoliaBuscador />
              </Route> */}

              <Route exact path="/FormasDePago">
                <FormasDePago onContentLoaded={handleContentLoaded} />
              </Route>
              <Route exact path="/Contacto">
                <Contacto onContentLoaded={handleContentLoaded} />
              </Route>
              <Route exact path="/QuienesSomos">
                <QuienesSomos onContentLoaded={handleContentLoaded} />
              </Route>
              <Route exact path="/PoliticasCia">
                <PoliticasCia onContentLoaded={handleContentLoaded} />
              </Route>
              <Route exact path="/Notificaciones">
                <Notifications
                  NotificationsQty={NotificationsQty}
                  NotificationsMsg={NotificationsMsg}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path="/FAQs/:search?">
                <Faqs
                  getCartItems={getCartItems}
                  loggedInChecked={LoggedIn}
                  onCartChange={onCartChange}
                  deleteWishlistItem={deleteWishlistItem}
                  checkLogin={checkLogin}
                  LoggedInData={LoggedInData}
                  addWishlistItem={addWishlistItem}
                  wishlistItems={WishlistItems}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path="/TyC">
                <TyC onContentLoaded={handleContentLoaded} />
              </Route>

              <Route exact path="/PoliticasPrivacidad">
                <PoliticasPrivacidad onContentLoaded={handleContentLoaded} />
              </Route>

              <Route exact path={serviciosClienteRoute}>
                <ServiciosAlCliente
                  loggedInChecked={LoggedIn}
                  checkLogin={checkLogin}
                  LoggedInData={LoggedInData}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path={buscadorInsumosRoute}>
                <SuppliesContainer
                  cartItems={CartItems}
                  getCartItems={getCartItems}
                  loggedInChecked={LoggedIn}
                  onCartChange={onCartChange}
                  deleteWishlistItem={deleteWishlistItem}
                  checkLogin={checkLogin}
                  LoggedInData={LoggedInData}
                  addWishlistItem={addWishlistItem}
                  wishlistItems={WishlistItems}
                  onContentLoaded={handleContentLoaded}
                  SelectedPage={SelectedPage}
                  setSelectedPage={setSelectedPage}
                />
              </Route>

              <Route exact path="/UPDATES">
                <Updates LoggedInData={LoggedInData} />
              </Route>

              {/* <Route path={`${loginRoute}/:error?/:origin?/:id?/`}>
              <LoginForm
                handleLogin={handleLogin}
                username={Username}
                LoggedIn={LoggedIn}
                handleLoginRRSS={handleLoginRRSS}
                RRSSLoginStatus={RRSSLoginStatus}
              />
            </Route>

            <Route path={`${registerRoute}/:error?/:origin?/:id?/`}>
              <RegisterForm
                handleLogin={handleLogin}
                username={Username}
                LoggedIn={LoggedIn}
                handleLoginRRSS={handleLoginRRSS}
                RRSSLoginStatus={RRSSLoginStatus}
              />
            </Route>

            <Route exact path={recoverRoute}>
              <Recover />
            </Route> */}

              {loggedInChecked && (
                <Route path={routes.checkout}>
                  <CheckoutContainer
                    LoggedInData={LoggedInData}
                    cartItems={CartItems}
                    LoggedIn={LoggedIn}
                    getCartItems={getCartItems}
                    checkLogin={checkLogin}
                  />
                </Route>
              )}

              <Route path={`${routes.checkoutCompleted}/:orderId?`}>
                <CompleteOrder getCartItems={getCartItems} />
              </Route>

              <Route path={`${routes.paymentError}`}>
                <PaymentError getCartItems={getCartItems} />
              </Route>

              <Route path={`${routes.checkoutRejected}`}>
                <RejectedOrder getCartItems={getCartItems} />
              </Route>

              <Route exact path={`${userInfoRoute}/:page?/:from?/`}>
                <UserInfoContainer
                  getCartItems={getCartItems}
                  checkLogin={checkLogin}
                  loggedInData={LoggedInData}
                  wishlistItems={WishlistItems}
                  deleteWishlistItem={deleteWishlistItem}
                  addWishlistItem={addWishlistItem}
                  addCartItems={addCartItems}
                  onCartChange={onCartChange}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route exact path={registerPendingConfirmationRoute}>
                <RegisterPendingConfirmation onContentLoaded={handleContentLoaded} />
              </Route>

              <Route path={`${testRoute}`}>
                <YourComponent DistrictsData={DistrictsData} getDistrictsData={getDistrictsData} />
              </Route>
              <Route path={`${searchRoute}/:key?`}>
                <SearchResults
                  IdListFromBusqueda={IdListFromBusqueda}
                  setIdListFromBusqueda={setIdListFromBusqueda}
                />
              </Route>
              <Route path="/:accessType/:accessValue/:accessType2?/:accessValue2?">
                <Catalogue
                  cartItems={CartItems}
                  getCartItems={getCartItems}
                  loggedInChecked={LoggedIn}
                  onCartChange={onCartChange}
                  deleteWishlistItem={deleteWishlistItem}
                  checkLogin={checkLogin}
                  addWishlistItem={addWishlistItem}
                  wishlistItems={WishlistItems}
                  onContentLoaded={handleContentLoaded}
                  SelectedPage={SelectedPage}
                  setSelectedPage={setSelectedPage}
                />
              </Route>
              <Route exact path="/Ofertas">
                <Offers
                  getCartItems={getCartItems}
                  loggedInChecked={LoggedIn}
                  onCartChange={onCartChange}
                  deleteWishlistItem={deleteWishlistItem}
                  checkLogin={checkLogin}
                  addWishlistItem={addWishlistItem}
                  wishlistItems={WishlistItems}
                  onContentLoaded={handleContentLoaded}
                  SelectedPage={SelectedPage}
                  setSelectedPage={setSelectedPage}
                />
              </Route>
              <Route exact path="/Novedades">
                <Novedades
                  getCartItems={getCartItems}
                  loggedInChecked={LoggedIn}
                  onCartChange={onCartChange}
                  deleteWishlistItem={deleteWishlistItem}
                  checkLogin={checkLogin}
                  addWishlistItem={addWishlistItem}
                  wishlistItems={WishlistItems}
                  onContentLoaded={handleContentLoaded}
                  SelectedPage={SelectedPage}
                  setSelectedPage={setSelectedPage}
                />
              </Route>

              <Route exact path={routes.home}>
                {homePage()}
              </Route>

              <Route exact path={wishlistRoute}>
                <Wishlist
                  loggedInData={LoggedInData}
                  cartItems={CartItems}
                  deleteCartItem={deleteWishlistItem}
                  addCartItems={addCartItems}
                  getCartItems={getCartItems}
                  WishlistItems={WishlistItems}
                  deleteWishlistItem={deleteWishlistItem}
                  onContentLoaded={handleContentLoaded}
                />
              </Route>

              <Route onContentLoaded={handleContentLoaded}>{homePage()}</Route>
            </Switch>
          </Suspense>
          {contentLoaded && <Footer handleLogout={handleLogout} />}
        </>
      )}
      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/5491136653543" // Cambiá por tu número con código de país
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          backgroundColor: '#25D366',
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px 2px 10px rgba(0,0,0,0.3)',
          zIndex: 9999,
          color: 'white',
          fontSize: '30px',
          textDecoration: 'none',
        }}
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default App;
